import { render } from "./home.vue?vue&type=template&id=69683eda&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=69683eda&scoped=true&lang=css"

import exportComponent from "D:\\project\\weetgo\\doo3dexamples\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69683eda"]])

export default __exports__